// extracted by mini-css-extract-plugin
export default {"container":"Title_container__0Vd+b","image":"Title_image__2hAyk","title":"Title_title__mBEUd","subtitle":"Title_subtitle__gv4GQ"};